// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1qtWd","calendarButtons":"ClockData_calendarButtons__2aVM3"};